import { Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import { ngListService } from '../../../list/core/ng-list.service';
import { EntityType } from '../../../rl-common/shared/shared/entity-type.enum';
import { BoxTab } from '../../../rl-common/tabs/box-tabs/box-tab';
import { ConditionBoxTab } from '../../../rl-common/tabs/box-tabs/condition-box-tab';
import { FlagService } from '../../../core/flag.service';
import { SidePanelStateComponent } from '../../shared/side-panel-state-component';
import { FormType } from '../../../rl-common/forms/shared/form-type.enum';
import { Section } from '../../../store/model/section.model';

@Component({
  selector: 'rl-add-new-item',
  templateUrl: './add-new-item.component.html',
  styleUrls: ['./add-new-item.component.scss']
})
export class AddNewItemComponent implements SidePanelStateComponent, OnInit{

  @Input() data: {
    type : FormType;
    entity : EntityType;
    section : Section;
    listId : string;
    onAdd : (item : any) => any;
  };

  @Input() showDefaultSection? : boolean;
  @Output() onSelectTab? = new EventEmitter<string>();

  exit: any;

  constructor(private flagService : FlagService, private listService : ngListService) { }

  currentView : string;
  tabs : BoxTab[] = [];

  sectionIndex : number;
  sectionsDropdown : Section[];

  //tabs
  fileTab : ConditionBoxTab = [new BoxTab('file', 'addItem.tabs.file'), this.flagService.isUploadFileAllowed];
  resourceTab : ConditionBoxTab= [new BoxTab('resource', 'addItem.tabs.resource'), this.listService.isThereCitationsWithPDF];
  manualFormTab : BoxTab = new BoxTab('resource', 'addItem.tabs.manualForm');
  librarySearchTab : BoxTab = new BoxTab('librarysearch', 'addItem.tabs.librarysearch');
  collectionTab : BoxTab = new BoxTab('manualForm', 'addItem.tabs.collection');
  mendeleyTab : ConditionBoxTab= [new BoxTab('mendeley', 'addItem.tabs.mendeley'), this.flagService.isMendeleySupported];
  refworksTab : ConditionBoxTab= [new BoxTab('refworks', 'addItem.tabs.refworks'), this.flagService.isRefworksSupported];
  zoteroTab : ConditionBoxTab= [new BoxTab('zotero', 'addItem.tabs.zotero'), this.flagService.isZoteroSupported];
  //

  readonly defaultTabs : {[key in FormType]? : (BoxTab | ConditionBoxTab)[]}= {
    [FormType.ASSIGNMENT_NEW_WELCOME] : [this.fileTab, this.resourceTab],
    [FormType.ASSIGNMENT] : [this.fileTab, this.resourceTab],
    [FormType.CITATION] : [this.librarySearchTab, this.manualFormTab, this.fileTab, this.collectionTab, this.mendeleyTab, this.refworksTab, this.zoteroTab],
    [FormType.COLLECTION] : [this.librarySearchTab, this.manualFormTab, this.fileTab]
  }

  ngOnInit(): void {
    this.tabs = this.defaultTabs[this.data.type].filter(t => !t[1] || t[1](this.data.listId)).map(t => t[0] || t);
    // this.sectionsDropdown = this.listService.getSections(<any>this.data.entity, this.data.listId) || [];
    // this.addDefaultSection();
    // this.sectionIndex = this.data.section ? this.sectionsDropdown.findIndex(s => s.id == this.data.section.id) : 0;
  }

  addDefaultSection() {
    if(!this.showDefaultSection) {
      return;
    }

    let defaultSectionName = this.flagService.defaultSectionName();

    if(this.sectionsDropdown.some(s=> s.name == defaultSectionName)){
      //default section is already exist
      return;
    }

    this.sectionsDropdown.push(this.getDefaultSection());    
  }
  
  setSection = (item : any) => {
    let i = item || {};
    i.section = this.getDefaultSection(); //this.sectionsDropdown[this.sectionIndex];
    return i;
  }

  getDefaultSection(){
    let defaultSection = new Section();
    defaultSection.id = "0";
    defaultSection.name = this.flagService.defaultSectionName();
    defaultSection.parentList = this.listService.currentList.id;
    return defaultSection;
  }

  back() : void {
    this.currentView = '';
    this.onSelectTab.emit(this.currentView);
  }
  
  selectTab(tabCode : string){
    this.currentView = tabCode;
    this.onSelectTab.emit(this.currentView);
  }
}
